"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useMaasAccount = function useMaasAccount(_ref) {
  var config = _ref.config;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)({
    error: false,
    message: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      sellers = _useState6[0],
      setSellers = _useState6[1];

  var _useState7 = (0, _react.useState)({
    email: '',
    tenantIdMagalu: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      user = _useState8[0],
      setUser = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      currentSellerInternal = _useState10[0],
      setCurrentSellerInternal = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      sellerPermissions = _useState12[0],
      setSellerPermissions = _useState12[1];

  var _useState13 = (0, _react.useState)({
    status: 'loading',
    sellers: null
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      onSellerChanged = _useState14[0],
      setOnSellerChanged = _useState14[1];

  var token = config === null || config === void 0 ? void 0 : config.keycloakToken; // use config urls or environment variable

  var MAAS_ACCOUNT_API_URL = (config === null || config === void 0 ? void 0 : config.url) || process.env.REACT_APP_MAAS_ACCOUNT_API_URL;
  if (!MAAS_ACCOUNT_API_URL) throw Error('variável de ambiente REACT_APP_MAAS_ACCOUNT_API_URL é obrigatório');
  var getSellers = (0, _react.useCallback)(function () {
    var headers = new Headers({
      Authorization: "Bearer ".concat(token),
      'Content-Type': 'application/json',
      Accept: 'application/json',
      credentials: 'include'
    });
    var request = new Request("".concat(MAAS_ACCOUNT_API_URL, "/auth"), {
      headers: headers
    });
    return fetch(request);
  }, [MAAS_ACCOUNT_API_URL, token]);
  var getSellersPermissions = (0, _react.useCallback)(function () {
    var headers = new Headers({
      Authorization: "Bearer ".concat(token),
      'Content-Type': 'application/json',
      Accept: 'application/json',
      credentials: 'include'
    });
    var request = new Request("".concat(MAAS_ACCOUNT_API_URL, "/auth/permissions"), {
      headers: headers
    });
    return fetch(request);
  }, [MAAS_ACCOUNT_API_URL, token]);

  var setCurrentSeller = function setCurrentSeller(tenantId) {
    setOnSellerChanged({
      status: 'loading',
      sellers: null
    });
    var seller = sellers.find(function (seller) {
      return seller.tenantId === tenantId;
    });

    if (seller) {
      setCurrentSellerInternal(seller);
      sessionStorage.setItem('maas-tenantId', tenantId);
      setOnSellerChanged({
        status: 'completed',
        sellers: seller
      });
    } else {
      var sellerInternal = (sellers === null || sellers === void 0 ? void 0 : sellers[0]) || null;
      setCurrentSellerInternal(sellerInternal);
      sessionStorage.setItem('maas-tenantId', (sellerInternal === null || sellerInternal === void 0 ? void 0 : sellerInternal.tenantId) || '');
      setOnSellerChanged({
        status: 'completed',
        sellers: sellerInternal
      });
      setError({
        error: true,
        message: 'Não foi possivel alterar para organização selecionada.'
      });
      console.error("O tenantId ".concat(tenantId, " n\xE3o pertece a esse usu\xE1rio. tenantId ").concat(sellerInternal === null || sellerInternal === void 0 ? void 0 : sellerInternal.tenantId, " foi selecionado por padr\xE3o."));
    }
  };

  (0, _react.useEffect)(function () {
    setOnSellerChanged({
      status: 'loading',
      sellers: null
    }); // executa os request para sellers e permission

    Promise.all([getSellers(), getSellersPermissions()]).then(function (responses) {
      return Promise.all(responses.map(function (r) {
        return r.json();
      }));
    }).then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          result = _ref3[0],
          permissions = _ref3[1];

      if (!result.sellers || !Object.keys(permissions || {}).length) {
        setError({
          error: true,
          message: 'Não existe permissões cadastradas'
        });
      }

      setUser({
        email: result.email,
        tenantIdMagalu: result.tenantIdMagalu
      });
      setSellers(result.sellers);
      setSellerPermissions(permissions);
      setOnSellerChanged({
        status: 'completed',
        sellers: result.sellers
      });
    })["finally"](function () {
      return setLoading(false);
    });
  }, [getSellersPermissions, getSellers]);
  return {
    user: user,
    sellers: sellers,
    sellerPermissions: sellerPermissions,
    currentServices: currentSellerInternal === null || currentSellerInternal === void 0 ? void 0 : currentSellerInternal.services,
    setCurrentSeller: setCurrentSeller,
    currentSeller: currentSellerInternal,
    onSellerChanged: onSellerChanged,
    loading: loading,
    error: error,
    setError: setError
  };
};

var _default = useMaasAccount;
exports["default"] = _default;